<template>
    <div>
        <div layout="column" layout-align="start start" class="full-width mb20-pc px2-pc pb1-pc pt1-pc mb2-mobile px1-mobile bg-white">
            <div layout="row" layout-align="start center" class="full-width">
                <v-btn @click="newRepresentative" class="ml-0" flat outline color="secondary">
                    <span style="text-transform: none">{{$t('representatives.add_btn')}}</span>
                </v-btn>
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
                <span flex></span>
                <div class="hidden-sm-and-down">
                    <v-text-field :label="$t('schools.rep_place')" clearable height="20" prepend-inner-icon="mdi-magnify" v-model="filters.keywords" @keyup.enter="fetch"
                    flat outline hide-details
                    single-line style="width: 300px"
                    @click:clear="fetch"></v-text-field>
                </div>
            </div>

            <v-text-field v-if="displayFilters"  :label="$t('filters.keywords')" clearable v-model="filters.keywords" @keyup.enter="fetch" class="hidden-md-and-up full-width" :placeholder="$t('schools.rep_place')" @click:clear="fetch"></v-text-field>
        </div>

        <div
          v-if="loading"
          layout="row"
          layout-align="center center"
          class="mt-2 full-width"
        >
          <beat-loader
            :loading="loading"
            color="grey"
          ></beat-loader>
        </div>
        <div v-else layout="column" layout-align="start start" class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white">
            <div layout="row" layout-align="start center" layout-wrap class="full-width">
                <v-card v-for="r in representatives" layout="row" layout-align="start center" class="school-card pr1-pc mt3-pc" flat :to="``" :flex="$vuetify.breakpoint. smAndDown ? 100 : 50" :key="'rep_'+r.id">

                    <div class="ma3-pc ma1-mobile pa2-pc pa1-mobile">
                        <avatar @click.native="editRepresentative(r)" class="clickable" size="50" :image="getImageData(r.id)" :fullname="r.firstname + ' ' + r.lastname"></avatar>
                    </div>

                    <div layout="column" flex>
                        <div @click="$router.push({name: 'representatives-show', params: {id: r.id}})" class="subheading ml-1">
                            {{r.firstname}}
                            <span class="font-weight-bold">
                                {{ r.lastname }}
                            </span>
                            <v-icon v-if="(r.sector == primary) && !r.cycle_id" color="warning" :title="$t('representatives.cycle_miss')">mdi-alert</v-icon>
                            <v-icon v-else-if="(r.sector == secondary) && !r.regime_id" color="warning" :title="$t('representatives.regime_miss')">mdi-alert</v-icon>
                        </div>
                        <div class="caption ml-1">
                            <a :href="'mailto:' + r.email" class="break-word">{{r.email}}</a>
                        </div>
                        <div layout="row" layout-wrap layout-align="start center">
                        <v-chip label :color="levelColor(r.level)" class="text-lowercase" text-color="white"  small>
                            {{levelLabel(r.level)}}
                        </v-chip>
                        </div>
                    </div>
                    <div layout="column">
                        <div :layout="$vuetify.breakpoint. smAndDown ? 'column' : 'row'" layout-align="center center">
                            <v-btn @click="editRepresentative(r)" :title="$t('_.edit')" class="mx-0 ma0-mobile" icon ><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                            <v-btn :title="r.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0 ma0-mobile" icon @click="toggle(r)">
                                <v-icon color="secondary">{{ r.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                            </v-btn>
                            <v-btn :title="$t('_.delete')" class="mx-0 ma0-mobile" icon @click="openDelete(r)">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </div>
            <div class="text-xs-center mt-5 full-width">
            <v-pagination
                v-model="filters.page"
                :length="pages" color="secondary"
                total-visible="5"
                @input="fetch"
                ></v-pagination>
            </div>
        </div>

        <representative-form :visible.sync="representativeDialog" @created="fetch(); $emit('updated')" @updated="fetch" :value="editingRepresentative"></representative-form>
        <v-dialog
          v-model="deleteDialog"
          max-width="300"
        >
          <v-card>
            <v-card-title class="title">{{$t('representatives.delete')}}</v-card-title>
            <v-card-text>
              {{$t('representatives.delete_details')}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                flat="flat"
                @click="deleteDialog = false"
              >
                {{$t('_.cancel')}}
              </v-btn>
              <v-btn
                color="error"
                depressed
                @click="deleteDialog = false; deleteRepresentative()"
              >
                {{$t('_.delete')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Representatives from '@/api/representatives'
    import I18nMixin from '@/mixins/i18n'
    import Consts from '@/consts'
    import Avatar from '@/components/shared/Avatar.vue'
    import RepresentativeForm from '@/components/shared/RepresentativeForm.vue'
    import ImageMixin from '@/mixins/image'
    import BeatLoader from "vue-spinner/src/BeatLoader.vue"

    export default {
        components: {Avatar, RepresentativeForm, BeatLoader},
        mixins: [I18nMixin, ImageMixin],
        props: {
            school: {
                required: true,
                type: Object,
                default () {
                    return { city: {} }
                }
            }
        },
        data () {
            return {
                filters: {
                    keywords: null,
                    is_enabled: null,
                    sector: [],
                    rowsPerPage: 10,
                    descending: 1,
                    sortBy: 'is_enabled',
                    page: 1,
                    school_id: this.$route.params.id
                },
                representatives: [],
                displayFilters: false,
                total: 0,
                imgs: {},
                imgsLoad: {},
                loading: false,
                representativeDialog: false,
                deleteDialog: false,
                deleting: null,
                editingRepresentative: {
                    lang_id: 'fr',
                    langs_ids: [],
                    sector: null,
                    school_id: this.$route.params.id,
                    birthday: null,
                    mandate_start: null,
                    mandate_end: null
                }
            }
        },
        mounted () {
            this.fetch();
        },
        watch: {
            representativeDialog(val){
                if(!val){
                    this.editingRepresentative = {
                        lang_id: 'fr',
                        langs_ids: [],
                        sector: null,
                        school_id: this.$route.params.id,
                        birthday: null,
                        mandate_start: null,
                        mandate_end: null
                    };
                }
            }
        },
        methods: {
            openDelete(r) {
              this.deleting = r
              this.deleteDialog = true
            },
            deleteRepresentative () {
              this.loading = true
              Representatives.delete(this.deleting.id).then(
                () => {
                  this.fetch()
                  this.$emit('updated')
                  this.$snotify.success(this.$t("representatives.removed"))
                },
                () => {
                  this.loading = false
                }
              )
            },
            fetch () {
                this.loading = true
                Representatives.getList(this.filters).then(res => {
                    this.representatives = res.data.items;
                    this.total = res.data.total;

                    for(let i = 0; i< this.representatives.length; i++){
                        if(this.representatives[i].avatar_id){
                            this.getImage('/assets/users/' + this.representatives[i].id, this.representatives[i].id);
                        }
                    }

                    this.loading = false
                })
            },
            newRepresentative () {
                this.representativeDialog = true;
            },
            editRepresentative (r) {
                this.editingRepresentative = Object.assign({}, JSON.parse(JSON.stringify(r)));
                if(this.editingRepresentative.langs_ids === undefined){
                    this.editingRepresentative.langs_ids = [];

                    for(let i = 0; i < this.editingRepresentative.langs.length; i++){
                        this.editingRepresentative.langs_ids.push(this.editingRepresentative.langs[i].id);
                    }
                }
                this.representativeDialog = true;
            },
            resetFilters () {
                this.filters = {
                    keywords: null,
                    is_enabled: null,
                    sector: [],
                    rowsPerPage: 10,
                    descending: 1,
                    sortBy: 'is_enabled',
                    page: 1,
                    school_id: this.$route.params.id
                };
                this.fetch();
            },
            toggle (item) {
                if (item.is_enabled) {
                    Representatives.disable(item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('representatives.disable'))
                    })
                } else {
                    Representatives.enable(item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('representatives.enable'))
                    })
                }
            },
            itemName(item){
                return this.i18n(item.name);
            },
            itemLabel(item){
                return this.i18n(item.label);
            },
            levelLabel(l){
                switch (l) {
                    case Consts.MINISTRY:
                        return this.$t('users.lv_min');
                    case Consts.NATIONAL:
                        return this.$t('users.lv_nat');
                    case Consts.SECTORAL:
                        return this.$t('users.lv_sec');
                    case Consts.LOCAL:
                        return this.$t('users.lv_loc');
                }
            },
            levelColor(l){
                switch (l) {
                    case Consts.MINISTRY:
                        return 'primary';
                    case Consts.NATIONAL:
                        return 'pink';
                    case Consts.SECTORAL:
                        return 'secondary';
                    case Consts.LOCAL:
                        return 'brown';
                }
            },
        },
        computed: {
            sectors () {
                return [
                    { value: Consts.PRIMARY, text: this.$t('schools.sector_prim') },
                    { value: Consts.SECONDARY, text: this.$t('schools.sector_sec') },
                    { value: Consts.COMPETENCECENTRE, text: this.$t('schools.sector_comp') },
                ]
            },
            primary(){
                return Consts.PRIMARY;
            },
            secondary(){
                return Consts.SECONDARY;
            },
            pages () {
                return Math.ceil(this.total / this.filters.rowsPerPage);
            }
        }
    }
</script>
<style scoped>
.search-bar {
  width: 400px;
}

.search-bar .v-input {
  border: 1px solid #dddddd;
  border-radius: 4px;
}
</style>
